// Tijden van de aanloop naar het target ("Meter naar 100"), gedeeld door de
// wijzer (AnimationLayer.js), de tikken (audio/cues.js) en de CSS. De meter
// vliegt van de hero naar het midden terwijl de wijzer naar 0 zakt, en trekt
// dan steeds sneller op naar 100.

// De vlucht naar het midden; de wijzer zakt in dezelfde tijd van 100 naar 0.
export const targetFlyMs = 900;

// Een tel stil op 0 voor hij begint.
export const targetSweepStartMs = targetFlyMs + 250;

export const targetSweepMs = 3200;

// De stand is (tijd)^dit: hoger begint trager en eindigt sneller, zodat 100 als een klap voelt.
const sweepPower = 2.2;

export const targetFullMs = targetSweepStartMs + targetSweepMs;

// Zo lang na de 100 valt "GEHAALD", zie targetPartyGroup in ./party.js.
export const targetHandoffMs = targetFullMs + 700;

// Blijft staan tot het donker van de kaart het overneemt, anders licht het scherm op.
export const targetChargeMs = targetHandoffMs + 500;

// De stand van de wijzer (0 tot 1) na `ms`: leeglopen tijdens de vlucht, dan optrekken.
export function targetSweepAt(ms) {
  if (ms < targetFlyMs) {
    const flown = Math.max(0, ms / targetFlyMs);
    return (1 - flown) ** 2;
  }
  const part = Math.min(1, Math.max(0, (ms - targetSweepStartMs) / targetSweepMs));
  return part ** sweepPower;
}

// Andersom: wanneer de wijzer bij `fraction` is. Daar hangen de tikken aan.
export function targetMarkMs(fraction) {
  return targetSweepStartMs + targetSweepMs * fraction ** (1 / sweepPower);
}

// Een tik om de 5%.
export const targetMarks = 20;
